import { forwardRef } from 'react'
import { InputNumber as AntInputNumber, InputNumberProps } from 'antd'
import cl from 'classnames'

import styles from './styles.module.scss'

const InputNumber = forwardRef<HTMLInputElement, InputNumberProps>(
	({ className, ...props }, ref) => {
		return (
			<AntInputNumber
				size="small"
				{...props}
				className={cl(styles.inputNumber, className)}
				ref={ref}
			/>
		)
	}
)

export default InputNumber
